<div class="learn-more-col">
  <div class="collapsable-header-cont" [class.collapsed-header]="isMobileLinksCollapsed">
    <div class="new-more-header new-title">
      <tra slug="lbl_explore_mpt"></tra>
      <span class="secondary-title">{{highlightedTitle}}</span>
    </div>
    <div class="learn-more-toggle" (click)="toggleMobileLinksCollapse()">
      <a>
        <span class="icon">
          <i *ngIf="isMobileLinksCollapsed" class="fa fa-chevron-right" aria-hidden="true"></i>
          <i *ngIf="!isMobileLinksCollapsed" class="fa fa-chevron-down" aria-hidden="true"></i>
        </span>
      </a>
    </div>
  </div>
  <div class="learnmore-link-tree new-links" [class.is-mobile-collapsed]="isMobileLinksCollapsed">
    <ul>
      <li class="learnmore-topic" *ngFor="let topic of getTopics()">
        <div class="menu-item-wrapper">
          <div class="menu-header">
            <a [routerLink]="getNodePath(topic)"  class="learnmore-link new-title"
              [class.is-active]="isTopicSelected(topic) && !isAnySubTopicSelected(topic)">
              {{getTitleTranlsated(topic.path)}}
            </a>
            <a (click)="handleToggleTopic(topic)" *ngIf="topic.sub?.length" class="toggle-btn">
              <span class="icon">
                <i [class]="topic.toggled ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
              </span>
            </a>
          </div>
          <div *ngIf="topic.sub && topic.sub.length && topic.toggled">
            <div class="learnmore-subtopics-container">
              <div class="learnmore-subtopic" *ngFor="let subtopic of topic.sub">
                <a [routerLink]="getNodePath(subtopic)" class="learnmore-link new-title"
                  [class.is-active]="isSubTopicSelected(subtopic)">{{getTitleTranlsated(subtopic.path)}}</a>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>